export default {
  name: 'columnsResizable',
  mounted(el, binding, vnode) {
    if (!binding.instance.resizeColumn) return;
    if (!binding.instance.$slots.header) return;

    const nodeName = el.nodeName;
    if (binding.value.child) return;
    console.log(vnode, 'vnode');
    const table = nodeName === 'TABLE' ? el : el.parentElement;
    const header = table.querySelector('.table-guide');
    const thead = table.querySelector('thead');
    const trs = thead.querySelector('tr');
    const ths = thead.querySelectorAll('th');
    const barHeight = nodeName === 'TABLE' ? table.offsetHeight : el.offsetHeight;
    const dumpHeaders = vnode.context.dumpHeaders;

    const resizeContainer = document.createElement('div');
    table.style.position = 'relative';
    resizeContainer.style.position = 'relative';
    resizeContainer.style.width = table.offsetWidth + 'px';
    resizeContainer.className = 'sc-columns-resizable';
    header.prepend(resizeContainer);

    let moving = false;
    let movingIndex = 0;
    let lastIndex = 0;
    let childrenLen = 0;
    let dumpIdx = 0;
    const isCheckType =
      !ths[0].className &&
      ths[0].children.length > 0 &&
      ths[0].children[0].classList[0] === 'lego-checkbox';
    lastIndex = ths.length - (isCheckType ? 2 : 1);

    ths.forEach((th, index) => {
      if (
        vnode.context.multiRowHeader > 0 &&
        !th.getAttribute('colspan') &&
        !th.getAttribute('rowspan')
      )
        return;
      if (index > 0) {
        if (dumpHeaders[dumpIdx].children) {
          childrenLen = childrenLen + dumpHeaders[dumpIdx].children.length;
        }

        dumpIdx = index + childrenLen;
      }

      const nextTh = ths[index + (isCheckType ? 2 : 1)];
      const bar = document.createElement('div');
      bar.style.position = 'absolute';
      bar.style.left = nextTh ? nextTh.offsetLeft - 2 + 'px' : 0;
      bar.style.top = '1px';
      bar.style.height = thead.getBoundingClientRect().height + 'px';
      bar.style.width = '4px';
      bar.style.cursor = 'col-resize';
      bar.style.disabled = isCheckType ? 'none' : '';
      bar.style.zIndex = 1001;
      bar.className = `columns-resize-bar ${dumpIdx} ${
        dumpHeaders[dumpIdx] ? dumpHeaders[dumpIdx].value : ''
      }`;

      bar.addEventListener('mousedown', () => {
        moving = true;
        vnode.context.directiveResize = true;
        movingIndex = index;
        dumpIdx = Number(bar.classList[1]);
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
      });
      if (vnode.context.multiRowHeader > 0 && trs.children.length - 1 > 0) {
        if (trs.children.length - (isCheckType ? 2 : 1) > resizeContainer.children.length)
          resizeContainer.appendChild(bar);
      } else {
        resizeContainer.appendChild(bar);
      }
    });

    const bars = resizeContainer.querySelectorAll('.columns-resize-bar');

    document.addEventListener('mouseup', () => {
      if (!moving) return;

      const bars = table.querySelectorAll('.columns-resize-bar');

      const setDump = Number(bars[movingIndex].classList[1]);
      moving = false;
      vnode.context.directiveResize = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      if (movingIndex === 0) {
        dumpHeaders[setDump].width = cutPx(bars[movingIndex].style.left) - (isCheckType ? 56 : 0);
      } else if (
        (dumpHeaders.children && dumpHeaders.children.length > 1) ||
        Math.sign(cutPx(bars[movingIndex].style.left) - cutPx(bars[movingIndex - 1].style.left)) !==
          1
      ) {
        if (dumpHeaders[setDump].children) {
          childSet(dumpHeaders[setDump].children, dumpHeaders[setDump].colspan);
        } else {
          dumpHeaders[setDump].width = 20;
        }
      } else {
        if (dumpHeaders[setDump].children) {
          childSet(dumpHeaders[setDump].children, dumpHeaders[setDump].colspan);
        } else {
          dumpHeaders[setDump].width =
            cutPx(bars[movingIndex].style.left) - cutPx(bars[movingIndex - 1].style.left);
        }
      }

      dumpHeaders[lastIndex].width = '*';
      const minSize = dumpHeaders[movingIndex].width;
      dumpHeaders[movingIndex].width = minSize <= 20 ? 20 : dumpHeaders[movingIndex].width;
      dumpHeaders[movingIndex].isMin = minSize <= 20 ? true : false;
      vnode.context.headerUpdate(dumpHeaders);
    });

    const childSet = (dumList, cols) => {
      dumList.forEach(child => {
        dumpHeaders.forEach((head, index) => {
          if (child === head.value) {
            if (head.children) {
              childSet(head.children, cols);
            } else {
              const childMinSize =
                (cutPx(bars[movingIndex].style.left) - cutPx(bars[movingIndex - 1].style.left)) /
                cols;
              dumpHeaders[index].width = childMinSize <= 20 ? 20 : childMinSize;
              dumpHeaders[index].isMin = childMinSize <= 20 ? true : false;
            }
          }
        });
      });
    };

    const cutPx = str => +str.replace('px', '');

    const handleResize = e => {
      if (moving) {
        const bar = bars[movingIndex];
        bar.style.left = cutPx(bar.style.left) + e.movementX + 'px';
        bar.style.height = barHeight + 'px';
      }
    };

    resizeContainer.addEventListener('mousemove', handleResize);
    table.addEventListener('mousemove', handleResize);
  },
  updated(el, binding, vnode) {
    if (!binding.instance.$slots.header) return;
    const nodeName = el.nodeName;
    if (binding.value.child) return;

    const table = nodeName === 'TABLE' ? el : el.parentElement;
    const thead = table.querySelector('thead');
    const ths = thead.querySelectorAll('th');
    const bars = table.querySelectorAll('.columns-resize-bar');
    const isCheckType =
      !ths[0].className &&
      ths[0].children.length > 0 &&
      ths[0].children[0].classList[0] === 'lego-checkbox';

    bars.forEach((bar, index) => {
      const nextTh = ths[index + (isCheckType ? 2 : 1)];
      bar.style.left = nextTh ? nextTh.offsetLeft - vnode.context.scrollLeft - 2 + 'px' : 0;
      bar.style.height = thead.getBoundingClientRect().height + 'px';
    });
  },
};
